<template>
    <transition name="modal">
        <div class="modal-mask" :class="modalclass" @click="(clickoutside) ? $emit('close') : ''">
            <div class="modal-wrapper">
                <div class="modal-container" @click="clickoutside ? handleClick($event) : null">

                    <div class="modal-header" v-if="showHeader">
                        <slot name="header">
                            default header
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            default body
                        </slot>
                    </div>

                    <div class="modal-footer" v-if="showFooter">
                        <slot name="footer">
                            default footer
                            <button class="modal-default-button" @click="$emit('close')">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            modalclass: {
                type: String,
                default: ''
            },
            clickoutside: {
                type: Boolean,
                default: true
            },
            showHeader: {
                type: Boolean,
                default: true
            },
            showFooter: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            handleClick: function(e) {
                e.stopPropagation();
            }
        }
    }
</script>